export function formatDate(dateString) {
  if (!dateString) return "—";
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(/ /g, "-")
}

export function formatTime(isoString) {
  if (!isoString) return "—";
  const timePart = isoString.split(/[T ]/)[1] || "";
  const [h, m] = timePart.split(":");
  if (h === undefined || m === undefined) return "—";
  return `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
}

export function formatDuration(totalMinutes) {
  if (totalMinutes === null || totalMinutes === undefined || Number.isNaN(Number(totalMinutes))) {
    return "—";
  }
  const minutes = Math.max(0, Math.round(Number(totalMinutes)));
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
}